import { Icon } from '@/components/ui/icon';
import { Text } from '@/components/ui/text';
import { SparklesIcon } from 'lucide-react-native';
import * as React from 'react';
import { View } from 'react-native';

export function PulseEmptyState() {
  return (
    <View className="mx-5 items-center gap-3 py-8">
      <View className="size-11 items-center justify-center rounded-full bg-primary/15">
        <Icon as={SparklesIcon} size={18} className="text-primary" />
      </View>
      <Text className="text-center text-[17px] font-semibold text-foreground">
        Pulse is quiet right now.
      </Text>
      <Text className="max-w-[280px] text-center text-[13px] leading-5 text-muted-foreground">
        New reminders, venue updates, and friend activity will land here.
      </Text>
    </View>
  );
}
